export const newList = {
	title: "Nueva lista de invitados",
	steps: {
		first: {
			title: "Datos de la lista",
			description: "¿Qué lista es esta?",
		},
		second: {
			title: "Clientes",
			description: "¿Quiénes son sus clientes?",
		},
		last: {
			title: "Lista lista",
			description: "Descarga e impresión",
		},
	},
	create: "Crear lista",
	view: "Visualizar lista creada",
	print: "Imprimir",
	list: "Lista",
	downloadList: "Descargar lista",
	forms: {
		firstStep: {
			title: "Nueva lista",
			name: {
				label: "Nombre de la lista",
				placeholder: "Escriba aquí el nombre de su lista",
				errorName: "Ingrese el nombre de la lista",
				errorLength: "El nombre de la lista debe tener menos de 100 caracteres",
			},
			expiresAtDate: {
				label: "Expiración de la lista",
				at: "a las",
				error: "Fecha y hora expirada",
			},
			addGuestTimeLimit: "Plazo límite de inserción de invitados",
			colorSelect: "Asignar un color",
			couvertPercentage: "Descuento en el cover",
			entranceIds: {
				label: "Entrada asociada",
				placeholder: "Seleccione el tipo de entrada asociada",
			},
			promoterIds: {
				label: "Promotores responsables de agregar invitados en esta lista",
				placeholder: "Para agregar escriba o seleccione",
				all: "Todos",
			},
			description: {
				label: "Descripción",
				placeholder: "Agregue una observación para su lista si lo desea",
				error: "La descripción de la lista debe tener menos de 280 caracteres",
				leftCharacters: "Quedan {{count}} caracteres",
			},
			canBeInvitedByLink: {
				label: "Compartir lista vía link",
				error: "Para que una lista sea compartible es necesario un límite de invitados",
			},
			isDocumentRequired: {
				label: "Documento obligatorio",
			},
			hasAutomaticEntranceCharge: {
				label: "Cobrar entrada automáticamente",
			},
			guestsLimitByPromoter: {
				label: "Límite de invitados por promotor",
				placeholder: "Ingrese el número límite",
			},
			guestsLimit: {
				label: "Límite de invitados",
				placeholder: "Ingrese el número límite",
			},
		},
		secondStep: {
			successImport: "Hoja de cálculo importada con éxito",
			label:
				"Puede agregar invitados manualmente o importar una hoja de cálculo. Si lo desea, puede continuar y agregar o importar invitados en otro momento.",
			title: "Cliente {{count}}",
			cpf: {
				label: "RFC",
				error: "RFC Inválido",
				duplicate: "RFC ya fue agregado",
			},
			name: {
				label: "Nombre y apellido",
				placeholder: "Escriba el nombre del invitado",
				error: "Nombre inválido",
			},
			phone: "Teléfono",
			promoter: {
				label: "Nombre del promotor",
				placeholder: "Nombre del responsable de la lista",
			},
			addNewClient: "Agregar invitado",
		},
		lastStep: {
			title: "Lista creada con éxito",
			cardTitle: "Descarga/impresión",
		},
	},
	goBackToLists: "Volver a listas",
};
